import axios from "axios";
import { companyName, senderId, smsApiKey, templateId } from "../../config";
// const baseUrl = "https://client-glfunnel-service-144135692330.asia-south1.run.app/api/v1";
// const baseUrl = "http://localhost:8080/api/v1";
const baseUrl = "https://lead-services-827695160227.asia-south1.run.app/api/v1";
const spinwheelService = {
  userCreation: (user) => {
    return axios.post(`${baseUrl}/spuser`, user);
  },
  getUserResult: (resultData) => {
    return axios.post(`${baseUrl}/spuser-result`, resultData);
  },
  getSpinWheelDetail: (docId) => axios.get(`${baseUrl}/sp-get-info/${docId}`),

  spinWheelResultAdd: (result) =>
    axios.post(`${baseUrl}/sp-result-add`, result),

  spinWheelResult: (result) => axios.post(`${baseUrl}/spuser-result`, result),
  getSpinWheelGeneralInfo: () => axios.get(`${baseUrl}/sp-general-info-get`),

  getTotalSpinCount: (docId) =>
    axios.post(`${baseUrl}/sp-count-update`, { docId: docId }),

  // getSendOTP: (phoneNumber, otpCode) => {
  //   const smsText = `Dear customer, ${otpCode} is your one time password (OTP) for Spin & Win Wheel. Please do not share the OTP with others. Regards, ${companyName}`;
  //   const enCodingSMS =  encodeURIComponent(smsText)
  //   // http://glsmsportal.in/api/smsapi?key=fc1b0ff640ea8c0b8ed177339cf3b230&route=1&sender=HSHUNT&number=8489713767&sms=Dear%20customer%2C%20676767%20is%20your%20one%20time%20password%20%28OTP%29%20for%20Spin%20%26%20Win%20Wheel.%20Please%20do%20not%20share%20the%20OTP%20with%20others.%20Regards%2C%20House%20Hunt%20India.&templateid=1707175212978928895
  //   return axios.get(
  //     `http://glsmsportal.in/api/smsapi?key=${smsApiKey}&route=1&sender=${senderId}&number=${phoneNumber}&sms=${enCodingSMS}&templateid=${templateId}`
  //   );
  // }

  sendOtpViaApi: (phoneNumber, otpCode) => axios.post(`${baseUrl}/send-otp`, { phone: phoneNumber, otp:otpCode }),
  
  
};

export default spinwheelService;
